import {signup, validateScreenName, createScreenName, getCountryList} from '@/libs/api/api'
import {isEmpty, cloneDeep, filter} from 'lodash'
import constants from '@/libs/constant/constants'
import pageRoutes from '@/libs/constant/pageRoutes'
import {
    message,
    errorHandler,
    logout, loader,
    openTermAndPrivacy
} from '@/libs/helper'
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            passwordType: 'password',
            confirmPasswordType: 'password',
            dynamicValidateForm: {
                first_name: '',
                last_name: '',
                screen_name: '',
                middle_name: '',
                email: '',
                password: '',
                confirmPassword: '',
                country_code: '',
                birth_date: new Date(new Date().setYear(new Date().getFullYear() - 18)),
                terms: true,
                productAndService: true
            },
            country_name: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > new Date().setYear(new Date().getFullYear() - 18);
                }
            },
            validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if (isEmpty(value) || (value && value.length > 20) || regex.test(value)) callback(new Error('Invalid screen name'))
                if (checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                else callback()
            },
        }
    },
    computed: {
        ...mapGetters({
            countryList: 'getCountryList'
        })
    },
    created () {
        this.fetchCountries()
    },
    mounted(){
        // var element = document.getElementsByClassName("el-icon-arrow-up");
        // element[0].classList.add("nova-carrot-up");
    },
    methods: {
        hideShowPassword(type, key){
            this[key] = type;
        },
        changeDate(date){
            this.dynamicValidateForm.birth_date = new Date(date)
        },
        submitForm (formName) {
            this.$refs[formName].validate(async(valid) => {
                if (valid) {
                    if(this.dynamicValidateForm.confirmPassword !== this.dynamicValidateForm.password){
                        message(this, constants.messageType.ERROR, ('Password and Confirm password not matched'))
                        return
                    }
                    if (!this.dynamicValidateForm.birth_date) {
                        return
                    }
                    loader(this, true);
                    let result = await this.validateMetaScreenName()
                    if (!result.isUnique) {
                        message(this, constants.messageType.ERROR, result.message || 'Screen name is already taken')
                        loader(this, false)
                        return
                    }
                    let dataToSend = cloneDeep(this.dynamicValidateForm)
                    if (dataToSend.middle_name === '') delete dataToSend.middle_name
                    dataToSend.country_name = this.country_name
                    dataToSend.service_notification = dataToSend.productAndService
                    delete dataToSend.terms;
                    delete dataToSend.productAndService;
                    delete dataToSend.confirmPassword;
                    signup(dataToSend).then((response)=> {
                        if (response && response.id) {
                            message(this, constants.messageType.SUCCESS, ('A verification link has been sent to your email, Please verify your email and login'), 5000);
                            this.$router.push(pageRoutes.signIn)
                        }
                        loader(this, false);
                    }).catch((error)=> {
                        loader(this, false);
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    })
                }
            })
        },
        openPage(page){
            openTermAndPrivacy(page)
        },
        handleInputConfirm (item) {
            this.dynamicValidateForm.country_code = item.country_code || ''
            this.country_name = item.country_name || ''
        },
        querySearch: async function (search, cb) {
            if (search === '' && search === null && search.length < 1) return 
            let results = []
                results = await filter((this.countryList || []), (c) => {
                return c.country_name.toLowerCase().includes(search.toLowerCase())
            })
            cb(results)
        },
        /**
         * to validate screen name of 
         * A/P/P on click of next button
         */
        validateMetaScreenName: async function () {
            try {
                // body for api call
                let body = {
                    entity_type: 'USER',
                    screen_name: this.dynamicValidateForm.screen_name
                }
                // api call
                let response = await validateScreenName(body)                
                return response
            } catch (error) {
                return error
            }
        },
        /**
         * to check for the first and last name 
         * and get the scrren name based on that 
         */
        checkForScreenName () {
            if (this.dynamicValidateForm.first_name && this.dynamicValidateForm.first_name !== '' && this.dynamicValidateForm.first_name.trim() !== '' && this.dynamicValidateForm.last_name && this.dynamicValidateForm.last_name !== '' && this.dynamicValidateForm.last_name.trim() !== '') {
                // body for api 
                let body = {
                    entity_type: 'USER',
                    name: `${this.dynamicValidateForm.first_name.trim()} ${this.dynamicValidateForm.last_name.trim()}`
                }
                createScreenName(body).then(response => {
                    this.dynamicValidateForm.screen_name = response.response
                }).catch(error => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
            }
        },
        async fetchCountries () {
            if (isEmpty(this.countryList)) {
                let response = await getCountryList();
                this.$store.dispatch('setCountryList', ((response && response.list) || []));
            } else {
                this.countries = cloneDeep(this.countryList)
            }
        },
    }
}